import React, { useEffect } from 'react';
import { Box, Container, Paper, Typography, Link, Divider } from '@mui/material';
import { TokenResponse } from '@react-oauth/google';

import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import { useUser } from '../../context/UserContext';

const ImprintPage = () => {
    const { login, isLoading } = useUser();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleSuccess = async (tokenResponse: TokenResponse) => {
        try {
            await login(tokenResponse);
        } catch (loginError) {
            console.error(loginError);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: (theme) =>
                    `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Header onLoginSuccess={handleSuccess} isLoading={isLoading} />

            <Container component="main" maxWidth="md" sx={{ flexGrow: 1, py: 4 }}>
                <Paper sx={{ p: { xs: 3, md: 5 } }}>
                    <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'primary.main' }}>
                        Imprint / Legal Notice
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                        Information according to § 5 TMG (and Slovenian ZGD-1)
                    </Typography>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        Company Information
                    </Typography>
                    <Typography paragraph>
                        <strong>ISN Group d.o.o., IT storitve in poslovno svetovanje, d.o.o.</strong><br />
                        Dunajska cesta 159<br />
                        1000 Ljubljana<br />
                        Slovenia
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        Contact
                    </Typography>
                    <Typography paragraph>
                        Email: support@ecom.time2future.com<br />
                        Website: https://ecom.time2future.com/
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        Registration
                    </Typography>
                    <Typography paragraph>
                        <strong>Registration Court:</strong> Okrožno sodišče v Ljubljani (District Court of Ljubljana)<br />
                        <strong>Registration Number (Matična št.):</strong> 9351809000<br />
                        <strong>VAT ID (Davčna št.):</strong> SI 20841515
                    </Typography>
                    <Typography paragraph>
                        <strong>Share Capital (Osnovni kapital):</strong> 7.560,00 EUR
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        Consumer Dispute Resolution
                    </Typography>
                    <Typography paragraph>
                        The European Online Dispute Resolution (ODR) Platform was discontinued on 20 July 2025.
                        <br /><br />
                        You can find a list of consumer dispute resolution entities in the EU Member States here:<br />
                        <Link
                            href="https://consumer-redress.ec.europa.eu/dispute-resolution-bodies"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://consumer-redress.ec.europa.eu/dispute-resolution-bodies
                        </Link>
                        <br /><br />
                        We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.
                    </Typography>

                    <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        Management
                    </Typography>
                    <Typography paragraph>
                        Managing Director: Irina Silnitskaya
                    </Typography>

                </Paper>
            </Container>

            <Footer />
        </Box>
    );
};

export default ImprintPage;
